import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface PromotionalSectionProps {
  title: string;
  description: string;
  primaryButtonText: string;
  primaryButtonLink: string;
  secondaryButtonText: string;
  secondaryButtonLink: string;
  variant?: "default" | "warning";
}

export default function PromotionalSection({
  title,
  description,
  primaryButtonText,
  primaryButtonLink,
  secondaryButtonText,
  secondaryButtonLink,
}: PromotionalSectionProps) {
  const titleClasses = "mb-2 text-xl font-semibold";

  const descriptionClasses = "text-small-content text-dark-grey";

  return (
    <section
      className={
        "md:p-6 p-3 my-8 border border-primary bg-secondary rounded-xl self-center md:self-auto mx-4 md:ml-10 w-fit"
      }
    >
      <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
        <div>
          <h2 className={titleClasses}>{title}</h2>
          <p className={descriptionClasses}>{description}</p>
        </div>
        <div className="flex flex-row gap-3">
          <Button asChild variant="outline">
            <Link to={secondaryButtonLink}>{secondaryButtonText}</Link>
          </Button>
          <Button asChild variant="default">
            <Link to={primaryButtonLink}>{primaryButtonText}</Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
